var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyphlens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90646 11.3429C4.85953 8.62909 5.09013 6.83671 5.91085 5.98683C6.73158 5.13694 8.51481 4.84393 11.2636 5.79551C13.9054 6.71009 17.0145 8.65532 19.9118 11.4532C22.8091 14.2511 24.8617 17.2904 25.8679 19.8988C26.9148 22.6126 26.6842 24.405 25.8635 25.2549C25.0428 26.1048 23.2595 26.3978 20.5108 25.4462C17.8689 24.5316 14.7599 22.5864 11.8626 19.7885C8.96523 16.9906 6.91268 13.9513 5.90646 11.3429ZM5.27445 5.37226C4.07026 6.61924 4.00834 8.88068 5.08105 11.6614C6.14323 14.4148 8.27953 17.5583 11.248 20.4249C14.2164 23.2915 17.4326 25.3168 20.2214 26.2822C23.0378 27.2572 25.2957 27.1164 26.4999 25.8694C27.7041 24.6225 27.766 22.361 26.6933 19.5803C25.6311 16.8269 23.4948 13.6834 20.5264 10.8168C17.5579 7.95023 14.3418 5.92494 11.553 4.95949C8.73654 3.98447 6.47865 4.12529 5.27445 5.37226Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9770_11256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5682 11.2277C26.6043 8.54184 26.3158 6.91703 25.6322 6.20909C24.9485 5.50115 23.3348 5.1561 20.6143 6.09788C18.0256 6.99406 14.9553 8.91034 12.0837 11.6834C9.21211 14.4565 7.18985 17.458 6.20387 20.0139C5.16772 22.6998 5.45624 24.3246 6.1399 25.0326C6.82355 25.7405 8.43729 26.0856 11.1577 25.1438C13.7464 24.2476 16.8168 22.3313 19.6884 19.5583C22.5599 16.7852 24.5822 13.7836 25.5682 11.2277ZM20.7475 20.655C26.7359 14.8721 29.4139 7.93026 26.7289 5.14995C24.044 2.36963 17.0129 4.80371 11.0246 10.5866C5.03618 16.3695 2.3582 23.3114 5.04312 26.0917C7.72804 28.872 14.7591 26.4379 20.7475 20.655Z",
    fill: "url(#paint0_linear_9770_11256)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9770_11256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5682 11.2277C26.6043 8.54184 26.3158 6.91703 25.6322 6.20909C24.9485 5.50115 23.3348 5.1561 20.6143 6.09788C18.0256 6.99406 14.9553 8.91034 12.0837 11.6834C9.21211 14.4565 7.18985 17.458 6.20387 20.0139C5.16772 22.6998 5.45624 24.3246 6.1399 25.0326C6.82355 25.7405 8.43729 26.0856 11.1577 25.1438C13.7464 24.2476 16.8168 22.3313 19.6884 19.5583C22.5599 16.7852 24.5822 13.7836 25.5682 11.2277ZM20.7475 20.655C26.7359 14.8721 29.4139 7.93026 26.7289 5.14995C24.044 2.36963 17.0129 4.80371 11.0246 10.5866C5.03618 16.3695 2.3582 23.3114 5.04312 26.0917C7.72804 28.872 14.7591 26.4379 20.7475 20.655Z",
    fill: "url(#paint1_linear_9770_11256)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5682 11.2277C26.6043 8.54184 26.3158 6.91703 25.6322 6.20909C24.9485 5.50115 23.3348 5.1561 20.6143 6.09788C18.0256 6.99406 14.9553 8.91034 12.0837 11.6834C9.21211 14.4565 7.18985 17.458 6.20387 20.0139C5.16772 22.6998 5.45624 24.3246 6.1399 25.0326C6.82355 25.7405 8.43729 26.0856 11.1577 25.1438C13.7464 24.2476 16.8168 22.3313 19.6884 19.5583C22.5599 16.7852 24.5822 13.7836 25.5682 11.2277ZM20.7475 20.655C26.7359 14.8721 29.4139 7.93026 26.7289 5.14995C24.044 2.36963 17.0129 4.80371 11.0246 10.5866C5.03618 16.3695 2.3582 23.3114 5.04312 26.0917C7.72804 28.872 14.7591 26.4379 20.7475 20.655Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9770_11256",
    x: 1,
    y: 0.999939,
    width: 29.772,
    height: 29.2418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_9770_11256"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9770_11256",
    x: 1,
    y: 0.999939,
    width: 29.772,
    height: 29.2418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_9770_11256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9770_11256",
    x1: 27.7731,
    y1: -4.19732e-7,
    x2: 4.77307,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9770_11256",
    x1: 27.7731,
    y1: -4.19732e-7,
    x2: 4.77307,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A383FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyphlens);
export default __webpack_public_path__ + "static/media/cyphlens.35a65bbbe5a0bb6b29fa6c965e6870d8.svg";
export { ForwardRef as ReactComponent };